export default {
  "content": "<path fill=\"none\" d=\"M0 0h16v16H0z\" data-name=\"Bounding box\"/><g fill=\"#3f4450\"><path d=\"M15 8.263a1 1 0 00-1 1V14H2V8.712a1 1 0 00-2 0V15a1 1 0 001 1h14a1 1 0 001-1V9.263a1 1 0 00-1-1z\"/><path d=\"M10.293 7.294L9 8.587V1a1 1 0 10-2 0v7.587L5.707 7.294a1 1 0 10-1.414 1.414l3 3a.99.99 0 00.326.217 1 1 0 00.764 0 .99.99 0 00.326-.217l3-3a1 1 0 10-1.414-1.414z\"/></g>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 16 16"
  }
};